import React, { useState, useEffect, useCallback } from "react";
import Card from "../components/Card";
import KCard from "../components/KCard";
import EditKcard from "../components/EditKcard";

import styles from "./CollectionPage.module.css";
import { deleteDoc, doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const CollectionPage = function (props) {
  const [searchTerm, setSearchTerm] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedKcard, setSelectedKcard] = useState(null);

  // HANDLE KCARD EDIT OVERLAY CLOSING
  const closeKcardEditOverlay = useCallback(function (e) {
    if (!e.target.closest("#editable-kcard")) {
      setIsEditing(false);
    }
  }, []);

  useEffect(() => {
    if (isEditing) {
      window.addEventListener("click", closeKcardEditOverlay);
    } else {
      window.removeEventListener("click", closeKcardEditOverlay);
    }
  }, [isEditing, closeKcardEditOverlay]);

  const galleryItems = props.collection
    .filter((kcard) => {
      if (searchTerm === "") {
        return kcard;
      }
      if (kcard.query.toLowerCase().includes(searchTerm)) {
        return kcard;
      }
      if (kcard.result.toLowerCase().includes(searchTerm)) {
        return kcard;
      }
    })
    .sort((prev, current) => prev.query.localeCompare(current.query)) //TODO: consider sorting the collection in initial data fetching
    .map((kcard, index) => {
      return (
        <Card key={index} className={styles["gallery-card"]}>
          <KCard
            kcardId={kcard.id}
            img={kcard.imgUrl}
            query={kcard.query}
            result={kcard.result}
            info={kcard.info}
            inputLang={kcard.inputLang}
            outputLang={kcard.outputLang}
            static={true}
          ></KCard>
        </Card>
      );
    });

  if (props.collection.length === 0) {
    return (
      <p className={styles["no-cards"]}>You have not created any cards 😢</p>
    );
  }

  const onChangeHandler = function (e) {
    const value = e.target.value.trim().toLowerCase();
    setSearchTerm(value);
  };

  const kcardClickHandler = function (e) {
    console.log(e.target);
    if (!e.target.closest("[data-kcard]") || e.target.closest("[data-volume]"))
      return;
    setIsEditing(true);
    const kcardData = JSON.parse(
      e.target.closest("[data-kcard]").dataset.kcard
    );
    setSelectedKcard(kcardData);
  };

  const deleteKcardHandler = async function (e) {
    console.log(`DELETING KCARD ${selectedKcard.id}`);
    try {
      await deleteDoc(doc(db, "kcards", selectedKcard.id));
      props.updateLocalCollection(
        props.collection.filter((kcard) => kcard.id !== selectedKcard.id)
      );
      setIsEditing(false);
      setSelectedKcard(null);
    } catch (err) {
      console.log(err);
      setIsEditing(false);
    }
  };

  const updateKcardHandler = async function (data) {
    console.log(`SAVING EDITED KCARD ${selectedKcard.id}`);
    const currentKcard = props.collection.find(
      (kcard) => kcard.id === selectedKcard.id
    );
    const updatedKcard = {
      ...currentKcard,
      imgUrl: data.img,
      query: data.query,
      result: data.result,
      info: data.info,
    };
    try {
      const docRef = doc(db, "kcards", selectedKcard.id);
      await setDoc(docRef, updatedKcard);
      const updatedLocalCollection = props.collection.filter(
        (kcard) => kcard.id !== selectedKcard.id
      );
      updatedLocalCollection.push(updatedKcard);
      props.updateLocalCollection(updatedLocalCollection);
      setIsEditing(false);
      setSelectedKcard(null);
    } catch (err) {
      console.log(err);
      setIsEditing(false);
    }
  };

  return (
    <div className={styles.container}>
      {isEditing && (
        <EditKcard
          id="editable-kcard"
          img={selectedKcard.imgUrl}
          query={selectedKcard.query}
          result={selectedKcard.result}
          info={selectedKcard.info}
          kcardId={selectedKcard.id}
          deleteKcardHandler={deleteKcardHandler}
          updateKcardHandler={updateKcardHandler}
        />
      )}
      <input
        className={styles.search}
        type="text"
        value={searchTerm}
        onChange={onChangeHandler}
        placeholder="Filter cards..."
      />
      <div className={styles["gallery-container"]} onClick={kcardClickHandler}>
        {galleryItems.length === 0 ? (
          <p className={styles["no-cards"]}>No matching cards found</p>
        ) : (
          galleryItems
        )}
      </div>
    </div>
  );
};

export default CollectionPage;
